import { VideoLook, VideoStyle } from '@/.gql/graphql';
import { TAiVideo } from '@/src/providers';

export const serializeAiVideos = (
  videoStyles: VideoStyle[],
  videoLooks: VideoLook[],
): TAiVideo[] => {
  const map = new Map<string, TAiVideo>();

  for (const style of videoStyles) {
    const key = JSON.stringify(style.name);
    map.set(key, {
      name: style.name,
      id: style.id,
      __typename: 'VideoStyle',
      videoStyleId: style.id,
      gendersShown: style.gendersShown,
      isNew: style.isNew,
      isBest: style.isBest,
      isPopular: style.isPopular,
      videoMan: style.videoMan,
      videoWoman: style.videoWoman,
      styleCategoryId: style.styleCategoryId,
      showResolutions: style.showResolutions,
    });
  }

  for (const look of videoLooks) {
    const key = JSON.stringify(look.name);
    if (map.has(key)) {
      const existing = map.get(key)!;
      existing.videoLookId = look.id;
      existing.imageMan ??= look.imageMan;
      existing.imageWoman ??= look.imageWoman;
      existing.isNew = existing.isNew || look.isNew;
      existing.isPopular = existing.isPopular || look.isPopular;
      existing.showResolutions = look.showResolutions;
    } else {
      map.set(key, {
        name: look.name,
        id: look.id,
        __typename: 'VideoLook',
        videoLookId: look.id,
        gendersShown: look.gendersShown,
        imageMan: look.imageMan,
        imageWoman: look.imageWoman,
        isNew: look.isNew,
        isBest: look.isBest,
        isPopular: look.isPopular,
        styleCategoryId: look.styleCategoryId,
        showResolutions: look.showResolutions,
      });
    }
  }

  return Array.from(map.values());
};
